import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const SpaServices = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my spa services business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps spa services businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for spa services businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most spa services businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my spa services business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like spa services. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Spa Services - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Spa Services CRM", url: "/industries/spa-services" }
  ];

  const industryData = {
    name: 'Day Spa',
    title: 'Fill Your Treatment Rooms & Build Membership Revenue',
    subtitle: 'Automate booking, reduce no-shows, and convert one-time visitors into monthly spa members',
    icon: '🧖',
    challenges: [
      'Treatment rooms not fully booked',
      'High no-show rates cost revenue',
      'One-time visitors don\'t return',
      'Hard to upsell additional services',
      'Membership programs underutilized'
    ],
    solutions: [
      'Online booking with package options',
      'Appointment reminder automation',
      'Return visit incentive campaigns',
      'Service upsell automation',
      'Membership promotion and tracking'
    ],
    features: [
      'Client CRM with treatment history',
      'Online booking system',
      'Appointment reminders',
      'Package and membership management',
      'Service upsell suggestions',
      'Gift certificate sales',
      'Retail product tracking',
      'Review automation'
    ],
    results: [
      '90% room utilization',
      '60% reduction in no-shows',
      '50% become members',
      '£6.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Spa Services UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for spa services businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for spa services UK, spa services business software, spa services customer management, spa services lead generation UK"
        url="/industries/spa-services"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default SpaServices;